import Vue from "vue";
import Router from "vue-router";
import user from "./user";
import admin from "./admin";
import error from "./error";

Vue.use(Router);

const router = new Router({
	mode: "history",
	routes: [
		// User
		{
			path: "/",
			name: "user",
			component: () => import("@/resources/user"),
			redirect: {
				name: "user.home",
			},
			children: user,
		},
		// Auth
		{
			path: "/auth",
			name: "auth",
			component: () => import("@/resources/auth"),
		},
		// Admin
		{
			path: "/admin",
			name: "admin",
			component: () => import("@/resources/admin"),
			redirect: {
				name: "admin.dashboard",
			},
			children: admin,
		},
		// Error
		{
			path: "/error",
			name: "error",
			component: () => import("@/resources/error"),
			redirect: {
				name: "error.404page",
			},
			children: error,
		},
		// 404page
		{
			path: "*",
			name: "error",
			component: () => import("@/resources/error"),
			redirect: {
				name: "error.404page",
			},
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	},
});

router.beforeEach(async (to, from, next) => {
	const loginStatus = localStorage.getItem("loginStatus");
	const userId = localStorage.getItem("userId");
	const toPageName = to.name.split(".")[0];
	if (toPageName == "admin") {
		if (loginStatus == "true" && userId) {
			next();
		} else {
			await localStorage.removeItem("loginStatus");
			await localStorage.removeItem("userId");
			next({ name: "auth" });
		}
	} else {
		next();
	}
});

export default router;
